<template>
  <div class="bottom-card">
    <v-card
      tile
      :class="{ 'screen-inset': $vuetify.breakpoint.mdAndUp }"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="primary--text">
              {{ $t('TaskList.BasketDoc') }}: <span class="pink--text ml-2">{{ numberOfSigningCartItem }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-spacer />

          <v-list-item-action :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }">
            <v-btn
              :disabled="numberOfSigningCartItem < 1"
              dark
              color="pink"
              :loading="loading"
              @click="showingConfirmDialog = true"
            >
              {{ $t('TaskList.Sign') }}
            </v-btn>

            <s-confirm-dialog
              v-model="showingConfirmDialog"
              :message="$t('eSign.GoToESignTrust')"
              :true-label="$t('ConfirmModal.OK')"
              :false-label="$t('Text.Cancel')"
              @confirm="getEsignLink"
            />
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>

import SConfirmDialog from '@/components/SConfirmDialog'
import { mapState } from 'vuex'
import store from '../../../store'
import { workflow } from '../../../store/modules/workflow/workflow'
import { workflowModule, staffModule } from '../../../store/moduleName'
import esignApi from '../../../api/esign/signing'
import { setStorage } from '../../../utils/storageUtil'
import { SIGN_BY_STAFFCODE_CB_URL } from '../../../constant/constant'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)
export default {
  components: {
    SConfirmDialog
  },
  data: function () {
    return {
      loading: false,
      showingConfirmDialog: false
    }
  },
  computed: {
    ...mapState(staffModule, {
      numberOfSigningCartItem: state => state.numberOfSigningCartItem
    }),
    ...mapState(workflowModule, {
      workItem: state => state.item
    })
    // readySignDocsNum: function () {
    //   let num = 0
    //   this.taskList.forEach(task => {
    //     if (task.status === true) {
    //       num++
    //     }
    //   })
    //   return num
    // }
  },
  created () {
    this.$store.dispatch(staffModule + '/countSigningCartItem')
  },
  methods: {
    getEsignLink: function () {
      this.loading = true
      esignApi.buildEsignLink(cb => {
        if (cb.status === 201 || cb.status === 200) {
          setStorage('g2e-redirectPath', this.workItem.url)
          setStorage('g2e-successMessageKey', 'TrainingClient.SaveSuccess')
          setStorage('g2e-failMessageKey', 'TaskList.eSign.FailMessage')
          // setStorage('g2e-signAndStartWorkflowUrl', workflowApi.signAndStartWorkflowUrl)
          location.href = cb.data
        }
        this.loading = false
      }, window.btoa(SIGN_BY_STAFFCODE_CB_URL))
    }
  }
}
</script>
